import script from "./third.vue?vue&type=script&setup=true&lang=js"
export * from "./third.vue?vue&type=script&setup=true&lang=js"

import "./third.vue?vue&type=style&index=0&id=33de0172&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33de0172"]])

export default __exports__